import { Helmet } from "react-helmet-async";

if (typeof document !== "undefined") document.querySelectorAll("meta[data-static]").forEach((m) => m.remove());

const SITE_NAME = "HomeHearth";
const SITE_TAGLINE = "Thoughtfully curated home & kitchen essentials for Indian homes";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function SEO({
  title,
  description,
  image,
  path = "/",
  type = "website",
  jsonLd = null,
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : `${SITE_NAME} — ${SITE_TAGLINE}`;
  const desc = description || SITE_TAGLINE;
  const url = `${BACKEND_URL}${path}`;
  const img = image || "https://images.pexels.com/photos/19836790/pexels-photo-19836790.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      <meta property="og:url" content={url} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      <meta name="robots" content="index, follow" />
      <meta name="theme-color" content="#5B7B53" />

      {jsonLd ? <script type="application/ld+json">{JSON.stringify(jsonLd)}</script> : null}
    </Helmet>
  );
}
